import * as React from "react";
import classNames from "classnames";

import AqButton from "../../Aq/Button";
import { backgroundStyleFromNode } from "../../../helpers/Doc/changes";
import { handleActions } from "../../../helpers/Doc/handleActions";

interface AiAssistantTextInputProps extends DocAiAssistantTextInputType<InlineNode>, BlockNodeAll {}

export default class AiAssistantTextInput extends React.PureComponent<AiAssistantTextInputProps> {
  render() {
    const {
      uid,
      value,
      onContinue,
    } = this.props;

    const boxLines = 5;

    return (
      <div
        id={uid}
        data-is-node
        data-uid={uid}
        className={classNames("doc-text-input", uid)}
        style={backgroundStyleFromNode(this.props)}
        contentEditable={false}
      >
        <textarea
          id={`textarea-${uid}`}
          cols={40}
          rows={boxLines}
          defaultValue={value || ""}
          aria-describedby={`char-count-live-region-${uid}`}
        />
        <div style={{ marginTop: "10px" }}>
          <AqButton type="button" onClick={() => { handleActions(onContinue, this.props); }}>
            SUBMIT
          </AqButton>
        </div>
      </div>
    );
  }
}
